<template>
    <div :class="{[showClass]: isVisible, [hideClass]: !isVisible}">
        <slot :hide="hide" :is-visible="isVisible"></slot>
    </div>
</template>

<script>
    export default {
        name: 'Collapsible',

        props: {
          showClass: {type: String, default: ''},
          hideClass: {type: String, default: 'hide'},
        },

        data() {
            return {
                isVisible: false,
            };
        },

        methods: {
            show() {
                this.isVisible = true;
            },
            hide() {
                this.isVisible = false;
            },
            toggle(status) {
                this.isVisible = status;
            }
        },
    }
</script>
